// extracted by mini-css-extract-plugin
module.exports = {"container":"Iletisim-module--container--1SpV1","iconBoxes":"Iletisim-module--iconBoxes--2hehJ"};